import React from "react";

const Overlay = () => {
  return (
    <div className="fixed top-0 left-0 right-0 min-h-screen bottom-0 bg-cyan-950/90 z-40"></div>
  );
};

export default Overlay;
